export default __webpack_public_path__ + "static/media/corazon-amarillo.f965717b.png";